import React from "react";
import TableFilter from "components/Shared/AppTable/TableFilter";
import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
import { useSearchParams } from "react-router-dom";
import ExportLocalTransportRule from "./ExportLocalTransportRule";
import { useCustomParams } from "hooks/useCustomParams";
import { useLazyGetDDLBranchListQuery } from "store/services/branchApi";
import { useAuth } from "hooks";

const LocalTransportRuleFilter = () => {
  const { params, appendParams } = useCustomParams();
  const [searchParams] = useSearchParams();
  const { viewEntity } = useAuth();

  const keyword = searchParams.get("search") || "";
  const branch = params.branch;
  const toBranch = params.toBranch;

  // Branches
  const [
    fetchBranches,
    {
      data: branchResponse = [],
      isLoading: loadingBranches,
      isFetching: fetchingBranches,
    },
  ] = useLazyGetDDLBranchListQuery();

  // Extract branches from response
  const branchList = React.useMemo(() => {
    if (!branchResponse) return [];

    // If response is an array directly
    if (Array.isArray(branchResponse)) {
      return branchResponse;
    }

    // If response has a data property that's an array
    if (branchResponse.data && Array.isArray(branchResponse.data)) {
      return branchResponse.data;
    }

    return [];
  }, [branchResponse]);

  const selectedBranch = branchList.find((b) => b._id === branch);
  const selectedToBranch = branchList.find((b) => b._id === toBranch);

  React.useEffect(() => {
    if (viewEntity?.entity?.account?._id && viewEntity?.entity?._id) {
      fetchBranches({
        account: viewEntity.entity.account._id,
        entity: viewEntity.entity._id,
      });
    }
  }, [fetchBranches, viewEntity]);


    const activeTab = searchParams.get("tab") || "Active";

    const filters = {
        keyword,
        branch,
        toBranch,
        active: activeTab === "Active",
    };

    return (
        <TableFilter
            initialFilters={2}
            actions={<ExportLocalTransportRule filters={filters} />}
        >
            {/* From Branch */}
            <BaseAutocomplete
                fullWidth
                label="From Branch"
                loading={loadingBranches || fetchingBranches}
                loadingText="Loading Branches..."
                options={branchList || []}
                getOptionLabel={(opt) => (opt ? opt.name : "")}
                isOptionEqualToValue={(option, value) =>
                    option?._id === value?._id
                }
                value={selectedBranch || null}
                onChange={(_, data) => {
                    appendParams({ branch: data?._id || "" });
                }}
            />

            {/* To Branch */}
            <BaseAutocomplete
                fullWidth
                label="To Branch"
                loading={loadingBranches || fetchingBranches}
                loadingText="Loading Branches..."
                options={branchList || []}
                getOptionLabel={(opt) => (opt ? opt.name : "")}
                isOptionEqualToValue={(option, value) =>
                    option?._id === value?._id
                }
                value={selectedToBranch || null}
                onChange={(_, data) => {
                    appendParams({ toBranch: data?._id || "" });
                }}
            />
        </TableFilter>
    );
};

export default LocalTransportRuleFilter;